module.exports = __webpack_public_path__ + "static/media/KernelCon Combined Logos_4.cc430301.png";